import Emoji from "./emoji";
import { getEntityStrategy } from "../../../utils/draft";

export const DECORATORS = [
  {
    strategy: getEntityStrategy("EMOJI"),
    component: Emoji,
  },
];
